import { useQuery } from '@tanstack/react-query'
import {
  GetRescueAreasWithinRadiusRequestBody,
  RescueArea,
} from '@twiceme-technology/api-types/v1/types'
import { RESCUE_AREAS } from './constants'
import api from '../axios'


export const getRescueAreasWithinRadius = async (
  radiusRequest: GetRescueAreasWithinRadiusRequestBody
) => {
  const { data } = await api.post<RescueArea[]>(
    RESCUE_AREAS.WITHIN_RADIUS,
    radiusRequest
  )
  return data
}

export const useGetRescueAreasWithinRadius = (
  radiusRequest: GetRescueAreasWithinRadiusRequestBody | undefined | null
) =>
  useQuery<RescueArea[], Error>({
    queryKey: ['rescueAreasWithinRadius', radiusRequest],
    queryFn: async () => {
      if (!radiusRequest) {
        throw new Error('No radius request provided')
      }

      return getRescueAreasWithinRadius(radiusRequest)
    },
    enabled: Boolean(radiusRequest),
  })
